// PERMANENT: Redirect to new pricing context
import { usePricing } from '../contexts/PricingContext';

export const useInstitutionalTrading = () => {
  // Redirect all calls to the new centralized pricing context
  return usePricing();
};
